/* Glossy Charm — bundle remove handler for grouped cart builds */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-bundle]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var keys = (btn.dataset.keys || '').split(',').filter(Boolean);
    if (!keys.length) return;

    btn.disabled = true;
    btn.textContent = 'Removing…';

    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart update failed');
        var inDrawer = btn.closest('#CartDrawer');
        if (inDrawer) {
          // Rebuilds the drawer via Impulse's existing listener
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Remove';
      });
  });
})();
